var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard container is-fluid"},[_c(_vm.dashboard,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }